export const SEARCH_ISOPEN = 'SEARCH_ISOPEN';
export const SEARCH_ISSUBMITTED = 'SEARCH_ISSUBMITTED';
export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH_RESET = 'SEARCH_RESET';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const SEARCH_VALUE = 'SEARCH_VALUE';

export const searchIsOpenToggle = () => ({ type: SEARCH_ISOPEN });
export const searchIsSubmitted = () => ({ type: SEARCH_ISSUBMITTED });
export const searchLoading = loading => ({ type: SEARCH_LOADING, loading });
export const searchReset = () => ({ type: SEARCH_RESET });
export const searchResults = results => ({ type: SEARCH_RESULTS, results });
export const searchValue = value => ({ type: SEARCH_VALUE, value });
